'use client';

import { usePageLoadTracking, useScrollTracking } from '@nrdy-marketing-engine/tracking';

export default function Tracking() {
  useScrollTracking();
  usePageLoadTracking();
  return null;
}
